export const ENTER_KEY_MODE = 0;
export const EDIT_MODE = 1;
export const DONE_MODE = 2;
export const READ_ONLY_MODE = 3;
export const LOAD_MODE = 4;
export const SHOW_ERROR_MODE = 5;
export const PORTAL_MODE = 6;
